import { siteData } from '@/mocks/siteData';

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1) return <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xs font-bold">1</span>;
  if (rank === 2) return <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 text-xs font-bold">2</span>;
  if (rank === 3) return <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-secondary-500 text-background-50 text-xs font-bold">3</span>;
  return <span className="w-7 h-7 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 text-xs font-bold">{rank}</span>;
}

function ChangeIcon({ change }: { change: 'up' | 'down' | 'same' | 'new' }) {
  if (change === 'up') return <i className="ri-arrow-up-line text-accent-600 text-sm"></i>;
  if (change === 'down') return <i className="ri-arrow-down-line text-foreground-400 text-sm"></i>;
  if (change === 'new') return <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 font-label">NEW</span>;
  return <span className="w-4 h-0.5 rounded-full bg-foreground-300 inline-block"></span>;
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-label mb-3">
            <i className="ri-fire-line"></i>爆料热榜
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            实时爆料热度排行榜
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            基于社区讨论热度的实时排名，看看大家都在关注什么
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/70 overflow-hidden">
          {siteData.ranking.map((item, idx) => (
            <a
              key={item.rank}
              href="#cards"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-primary-50/30 transition-colors cursor-pointer no-underline ${
                idx < siteData.ranking.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <RankBadge rank={item.rank} />

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-[10px] font-label px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <h3 className="font-label text-sm font-semibold text-foreground-900 line-clamp-1">
                  {item.title}
                </h3>
              </div>

              <div className="shrink-0 flex items-center gap-3">
                <span className="text-xs text-foreground-500 font-label whitespace-nowrap">
                  {item.heat}热度
                </span>
                <div className="w-6 flex items-center justify-center">
                  <ChangeIcon change={item.change} />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}